import { defineAsyncComponent } from 'vue';

export default function lazy(
  loader,
  { delay = 200, timeout = 30000, loading = null, error = null } = {}
) {
  return defineAsyncComponent({
    loader,
    delay,
    timeout,
    loadingComponent: loading,
    errorComponent: error,
  });
}
